const takeNoteStyle = {
    boxSizing:"border-box",
    boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
    borderRadius: "5px",
}

const takeNoteTextareaStyle = {
    boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
    padding: "0.75rem 1rem 0.25rem 1rem",
    borderRadius: "5px"
}

export { takeNoteStyle, takeNoteTextareaStyle};
